import(/* webpackMode: "eager" */ "/home/forge/te-rarawa.waxeye.dev/releases/67026030/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/home/forge/te-rarawa.waxeye.dev/releases/67026030/src/context/AppProviders.tsx");
